/**
 * 유저별 네임스페이스 — sync 스냅샷·기타 로컬 데이터 충돌 방지
 */
export function getDreamitySnapshotStorageKey(userId: string): string {
  return `dreamity_planner_sync_v1_${userId}`
}
